/* src/app/portals/portals.component.scss */
.custom-search {
  position: relative;
  margin: 0 auto 10px auto;
  max-width: 400px;
}
.custom-search input {
  padding-right: 35px;
}
.custom-search input::-ms-clear {
  display: none;
}
.custom-search-clear {
  position: absolute;
  top: 5px;
  right: 10px;
  padding: 5px;
  height: 25px;
  width: 25px;
  cursor: pointer;
  color: #a3acb5;
  text-align: center;
}
.custom-list-wrapper {
  height: 500px;
  margin: 0 auto;
  max-height: calc(100% - 70px);
  max-width: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}
.portal-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  margin-right: 10px;
}
.portal-logo .portal-logo-img {
  max-height: 30px;
  max-width: 30px;
}
.portal-name {
  max-width: 88%;
}
/*# sourceMappingURL=portals.component.css.map */
